import { render } from "./VocationalTraining.vue?vue&type=template&id=3b418b10"
import script from "./VocationalTraining.vue?vue&type=script&lang=js"
export * from "./VocationalTraining.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__